export class CategoryModel {
  name: string;
  type:string;

  constructor(){
    this.name = "";
    this.type = '';
  }
}
